class FAQCard extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.button = this.querySelector('button');
    this.button.addEventListener('click', this.handleClick.bind(this));
  }
  
  disconnectedCallback() {
    this.button.removeEventListener('click', this.handleClick.bind(this));
  }

  handleClick() {
    if (this.dataset.faqCardStatus === 'open') {
      this.dataset.faqCardStatus = 'close';
    } else {
      this.dataset.faqCardStatus = 'open';
    }
  }
}

customElements.define('faq-card', FAQCard);
